<template>
    <ColorForm :color="color" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ColorForm from './ColorForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    ColorForm
  },
  data() {
    return {
      color:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.color=await APIRequest.detail('colors',this.$route.params.id)
    this.loaded=true
  }
}
</script>
